var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import classNames from "classnames";
import { Button } from "../Button";
const defaultProps = {
    "data-testid": "tecma-dropDown-item",
};
const DropDownItem = (_a) => {
    var { children, id, style, className, onClick } = _a, rest = __rest(_a, ["children", "id", "style", "className", "onClick"]);
    const classList = classNames("tecma-dropDown-item", className);
    return (_jsx("li", Object.assign({ id: id, style: style, className: classList }, rest, { children: _jsx(Button, { onClick: onClick, fluid: true, color: "transparent", children: children }) })));
};
DropDownItem.defaultProps = defaultProps;
export default memo(DropDownItem);
